import moment from "moment";
import { FlagIcon } from "react-flag-kit";
import { useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";

import {
  getPlan,
  getLangAll,
  getAffiliateAll,
  getPaymentHistory,
  getAffiliateInfoById,
  postStudentPlansCancel,
  postStudentPlansRefund,
  postStudentPlansRenovate,
  setAffiliateInStudentPlan,
  postStudentPlansCancelImmediate,
} from "../../store/middleware";
import ButtonMB from "../../components/Buttons/Button";
import cancelImg from "../../assets/images/img-cancel-plan.png";
import { SCButtonAddInput } from "../../components/Buttons/styles";
import flagMultilingoPNG from "../../assets/images/flag_multilingo.png";
import IconPricing from "../../assets/images/sign-up/icon_pricing_world_blue.svg";

import { StudentManagementCss, Billing, ModalCommission } from "./styles";

function Plans({ id }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [showPlan, setShowPlan] = useState(true);
  const [userPlans, setUserPlans] = useState([]);
  const [cancelPlan, setCancelPlan] = useState(0);
  const [openalert, setOpenalert] = useState(false);
  const [sucessMsg, setSucessMsg] = useState(false);
  const [renovatePlan, setRenovatePlan] = useState(0);
  const [isAffiliate, setIsAffiliate] = useState(false);
  const [infoAffiliate, setInfoAffiliate] = useState({});
  const [responseError, setResponseError] = useState("");
  const [showPlanInfo, setShowPlanInfo] = useState(false);
  const [showManagePlan, setShowManagePlan] = useState(false);
  const [cancelPlanRefund, setCancelPlanRefund] = useState(0);
  const [selectedPlanName, setSelectedPlanName] = useState("");
  const [openalertRefund, setOpenalertRefund] = useState(false);
  const [openalertRenovate, setOpenalertRenovate] = useState(false);
  const [cancelPlanImmediate, setCancelPlanImmediate] = useState(0);
  const [openalertImmediate, setOpenalertImmediate] = useState(false);
  const [studentPlanSelected, setStudentPlanSelected] = useState(null);
  const [reasonForcancellation, setReasonForcancellation] = useState();
  const [showModalCommission, setShowModalCommission] = useState(false);
  const [showPaymentHistories, setShowPaymentHistories] = useState(false);
  const [reasonForcancellationimmediate, setReasonForcancellationimmediate] = useState();
  const [formCommission, setFormCommission] = useState({
    affiliateId: "",
    affiliateSlug: "",
    nameAffiliate: "",
    studentPlanPaymentId: "",
  });

  const getData = () => {
    dispatch(getPlan(id))
      .then((res) => {
        res.map((item) => {
          const { availableClasses } = item;
          const { totalClasses } = item.plan;
          item.cyclePercentage = 100 - (availableClasses / totalClasses) * 100;
          item.edit = false;
          let levels = item.student.studentLevelGrades;
          item.studentPlanLanguages.map((studentPlanLang) => {
            let level = levels.filter((level) => level.lingoLanguageId === studentPlanLang.lingoLanguageId);
            if (level.length > 0) {
              studentPlanLang.level = level[0].level.level;
            }
          });
        });

        setUserPlans(res);
        setShowManagePlan(false);
        setShowPaymentHistories(true);
        setShowPlan(true);
      })
      .catch((err) => {
        console.log("ERRO GET studentplans ", err);
      });

    dispatch(getLangAll());
  };

  const tooglePaymentHistory = (e, studentPlan, planId, show) => {
    e.preventDefault();

    const cancels = studentPlan?.studentPlanPayments?.find((item) => {
      return item.providerState === "Cancelled";
    });

    const hasCancelDate = studentPlan?.studentPlanPayments?.find((item) => {
      return item.providerCancelDate !== null && item.providerCancelDate !== undefined;
    });
    if (show && planId) {
      dispatch(getPaymentHistory({ studentId: userPlans[0].studentId, planId: planId, id: studentPlan.id }))
        .then(() => {
          setShowManagePlan(true);
          setShowPaymentHistories(true);
          setShowPlan(false);
          setSelectedPlanName(userPlans.filter((plan) => plan.id === studentPlan.id)[0].plan.nameEnglish);
          setStudentPlanSelected({ studentPlan, cancels: cancels ?? null, hasCancelDate });

          window.scrollTo(0, 0);
        })
        .catch((err) => {
          console.log("🚀 ~ err:", err);
        });
    } else {
      setShowPaymentHistories(false);
      setShowPlan(true);
    }
  };

  const handleSubmit = (e, submit) => {
    e.preventDefault();
    if (submit) {
      let changedPlanLanguage = [];
      userPlans.map(function (plan) {
        plan.studentPlanLanguages
          .filter((lang) => lang.edited === true)
          .map(function (planLang) {
            changedPlanLanguage.push({
              id: planLang.id,
              studentPlanId: planLang.studentPlanId,
              studentId: userPlans[0].studentId,
              lingoLanguageId: planLang.lingoLanguageId,
              focus: planLang.focus,
              struct: planLang.struct,
              randomFixedTeachers: planLang.randomFixedTeachers,
            });
          });
      });

      if (changedPlanLanguage.length < 1) {
        getData();
      }
    } else {
      getData();
    }
  };

  const handleCancelPlan = (v) => {
    setOpenalert(true);
    setCancelPlan(v);
  };

  const handleRenovatePlan = (v) => {
    setOpenalertRenovate(true);
    setRenovatePlan(v);
  };

  const handleCancelPlanImmdiate = (v) => {
    setOpenalertImmediate(true);
    setCancelPlanImmediate(v);
  };

  const handleRefund = (v) => {
    setOpenalertRefund(true);
    setCancelPlanRefund(v);
  };

  const openModalCommission = (e, studentPlan) => {
    e.preventDefault();
    setFormCommission((state) => ({
      ...state,
      studentPlanPaymentId: studentPlan.studentPlanPayments[0]?.id,
    }));
    setShowModalCommission(true);
  };

  const closeAlert = () => setOpenalert(false);
  const closeAlertRefund = () => setOpenalertRefund(false);
  const closeAlertRenovate = () => setOpenalertRenovate(false);
  const closeAlertImmediate = () => setOpenalertImmediate(false);
  const closeModalCommission = () => setShowModalCommission(false);

  const handleAffiliateSlug = (e) => {
    const { value } = e.target;

    if (value.length > 0) {
      const body = {
        name: "",
        login: "",
        pageSize: 20,
        pageNumber: 1,
        countryId: 0,
        active: "true",
        slug: value,
        subscriptionDate: "",
      };

      dispatch(getAffiliateAll(body)).then((affiliate) => {
        setFormCommission((state) => ({
          ...state,
          affiliateId: affiliate ? affiliate?.id : 0,
          nameAffiliate: affiliate ? affiliate?.user?.name : "Nao encontrado!",
        }));
      });
    }
  };

  const handleModalCommission = () => {
    if (!formCommission.affiliateSlug || formCommission.affiliateId === 0) return;
    dispatch(
      setAffiliateInStudentPlan({
        affiliateId: formCommission.affiliateId,
        studentPlanPaymentId: formCommission.studentPlanPaymentId,
      }),
    ).then((resp) => {
      if (resp) {
        getData();
        setSucessMsg(true);
      }
    });
  };

  const submitCancel = () => {
    const studentPlanId = cancelPlan.studentPlanPayments[0].studentPlanId;
    const provider = cancelPlan.studentPlanPayments[0].provider;

    const sendObj = {
      cancelNotes: reasonForcancellation,
    };

    dispatch(postStudentPlansCancel(studentPlanId, sendObj, provider))
      .then(() => {
        setSucessMsg("Your plan was cancelled. You can schedule classes until the end of your billing cycle.");
      })
      .catch((err) => {
        if (err.status > 201) {
          let msg = err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");

          setResponseError(message[1] !== undefined ? message[1] : err.data.error.message);
        } else if (Array.isArray(err.data.error)) {
          setResponseError(err.data.error[0].message);
        } else {
          setResponseError("Make sure all fields are filled in");
        }
      });
  };

  const submitCancelImmediate = () => {
    const studentPlanId = cancelPlanImmediate.studentPlanPayments[0].studentPlanId;

    const sendObj = {
      cancelNotes: reasonForcancellationimmediate,
    };

    dispatch(postStudentPlansCancelImmediate(studentPlanId, sendObj))
      .then(() => {
        closeAlertImmediate();
        window.location.reload();
      })
      .catch((err) => {
        if (err.status > 201) {
          let msg = err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");

          setResponseError(message[1] !== undefined ? message[1] : err.data.error.message);
        } else if (Array.isArray(err.data.error)) {
          setResponseError(err.data.error[0].message);
        } else {
          setResponseError("Make sure all fields are filled in");
        }
      });
  };

  const submitRefund = () => {
    const studentPlanId = cancelPlanRefund.studentPlanPayments[0].studentPlanId;

    dispatch(postStudentPlansRefund(studentPlanId))
      .then(() => {
        closeAlertRefund();
        window.location.reload();
      })
      .catch((err) => {
        if (err.status > 201) {
          let msg = err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");

          setResponseError(message[1] !== undefined ? message[1] : err.data.error.message);
        } else if (Array.isArray(err.data.error)) {
          setResponseError(err.data.error[0].message);
        } else {
          setResponseError("Make sure all fields are filled in");
        }
      });
  };

  const submitRenovatePlan = () => {
    const studentPlanId = renovatePlan.studentPlanPayments[0].studentPlanId;

    dispatch(postStudentPlansRenovate(studentPlanId))
      .then(() => {
        closeAlertRenovate();
      })
      .catch((err) => {
        if (err.status > 201) {
          let msg = err.data.error.message;
          msg = msg.replace(/\[/g, "").replace(/]/g, "");
          const message = msg.split("message:");

          setResponseError(message[1] !== undefined ? message[1] : err.data.error.message);
        } else if (Array.isArray(err.data.error)) {
          setResponseError(err.data.error[0].message);
        } else {
          setResponseError("Make sure all fields are filled in");
        }
      });
  };

  const textCancelClass = (studentPlan, t, dateCancel = "") => {
    const cancels =
      studentPlan.studentPlanPayments &&
      studentPlan.studentPlanPayments.find((item) => {
        return item.providerState === "Cancelled";
      });
    const hasCancelDate =
      studentPlan.studentPlanPayments &&
      studentPlan.studentPlanPayments.find((item) => {
        return item.providerCancelDate !== null && item.providerCancelDate !== undefined;
      });
    return hasCancelDate && !cancels ? (
      <div>
        <p style={{ color: "#FF5666", fontWeight: "200", fontSize: 14 }}>
          {t("THIS_PLAN")} <span style={{ color: "#FF5666", fontWeight: "bold" }}>{t("CANCELED_CYCLE")}</span>{" "}
          {dateCancel === "" ? t("RESET_CYCLE") : moment(dateCancel).format(t("DATE_FORMAT"))}
        </p>
      </div>
    ) : (
      <></>
    );
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <StudentManagementCss>
        {!showManagePlan && (
          <div className="planBox">
            {userPlans.map((studentPlan, planIndex) => {
              const cancels = studentPlan.studentPlanPayments.find((item) => {
                return item.providerState === "Cancelled";
              });

              const cyclePercentage =
                parseFloat((studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100) % 1 !== 0
                  ? parseFloat(100 - (studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100).toFixed(2)
                  : parseFloat(100 - (studentPlan.availableClasses / studentPlan.plan.totalClasses) * 100);

              return (
                <div key={"plan" + planIndex}>
                  <div className="box">
                    <div className="PlansBox">
                      <div className="plans">
                        <img src={IconPricing} alt="" width="40" height="40" />
                        <div className="changePlan">
                          <h2>{studentPlan.plan.nameEnglish}</h2>
                        </div>
                      </div>

                      {/* {Planos cancelados} */}
                      {!cancels ? (
                        <div className="plans">
                          <div className="controlPlan">
                            <div className="infos">
                              <h2>{t("SCHEDULING_CONTROL").toUpperCase()}</h2>
                              {studentPlan?.studentPlanPayments?.length > 0 && (
                                <h3>
                                  {t("RESETS_ON")}{" "}
                                  {moment(studentPlan.studentPlanPayments[0].providerNextCycleDate).format(
                                    "YYYY/MM/DD",
                                  )}
                                </h3>
                              )}
                              {studentPlan?.student.studentB2bs?.length > 0 && (
                                <h3>
                                  {t("RESETS_ON")}{" "}
                                  {moment(
                                    studentPlan.student?.contractPlanStudents[0]?.studentPlanB2BRenewalCycle?.nextCyc,
                                  )
                                    .utc()
                                    .format("YYYY/MM/DD")}
                                </h3>
                              )}
                            </div>
                            {studentPlan.plan.unlimited && (
                              <div className="numbers">
                                <span>
                                  <img
                                    alt="multilingo"
                                    src={flagMultilingoPNG}
                                    style={{ width: "24px", marginTop: "6px" }}
                                  />
                                </span>
                                <span style={{ color: "#00D36A" }}>Unlimited</span>
                              </div>
                            )}
                            {!studentPlan.plan.unlimited && (
                              <div className="numbers">
                                <span>{cyclePercentage}%</span>
                                <span>
                                  {studentPlan.plan.totalClasses - studentPlan.availableClasses}/
                                  {studentPlan.plan.totalClasses} classes
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="stock">
                            {studentPlan.plan.unlimited && <hr style={{ backgroundColor: "#00D36A" }} />}
                            {!studentPlan.plan.unlimited && (
                              <div>
                                <hr style={{ width: cyclePercentage + "%" }} />
                              </div>
                            )}
                            {studentPlan.availablePartClasses > 0 && (
                              <div>
                                <span>
                                  <b>{studentPlan.availablePartClasses}</b> <b>{t("EXTRA_CLASSES")}</b> {t("IN_STOCK")}.
                                </span>
                              </div>
                            )}
                            {user?.role === "companyManager" && studentPlan.student.studentB2bs?.length > 0 && (
                              <span>
                                <b>B2B Renewal Cycle: </b>
                                {studentPlan.student?.contractPlanStudents[0]?.studentPlanB2BRenewalCycle?.active.toString()}
                              </span>
                            )}
                          </div>
                          <div className="stock">
                            {textCancelClass(studentPlan, t, studentPlan.studentPlanPayments[0]?.providerCancelDate)}
                          </div>
                        </div>
                      ) : (
                        <div className="planCancel">{t("CANCELLED_PLAN")}</div>
                      )}

                      {studentPlan?.studentPlanPayments?.length > 0 && !cancels && (
                        <div>
                          {user?.role === "companyManager" &&
                            studentPlan.studentPlanPayments[0]?.affiliateId === null && (
                              <SCButtonAddInput
                                mt="20px"
                                mr="20px"
                                color="#fff"
                                background="#004fff"
                                onClick={(e) => openModalCommission(e, studentPlan)}
                              >
                                {t("CREATE_COMMISSION")}
                              </SCButtonAddInput>
                            )}

                          <SCButtonAddInput
                            mt="20px"
                            mr="20px"
                            color="#fff"
                            background="#004fff"
                            onClick={(e) => tooglePaymentHistory(e, studentPlan, studentPlan.planId, true)}
                          >
                            {t("MANAGE")}
                          </SCButtonAddInput>
                        </div>
                      )}
                    </div>
                    <hr />
                    {studentPlan.studentPlanLanguages.map((studentPlanLanguage, index) => {
                      return (
                        <div key={index} className="PlansBox teste">
                          <div className="plans">
                            <div className="payment">
                              <h2>{t("CARD_PLAN_COURSE")}</h2>
                              <h3>
                                <FlagIcon code={studentPlanLanguage.lingoLanguage.flag} />{" "}
                                {studentPlanLanguage.lingoLanguage.description}
                              </h3>
                            </div>
                          </div>
                          <div className="plans last">
                            <div className="payment">
                              <h2>{t("CARD_PLAN_SCHEDULE")}</h2>
                              <h3>{studentPlanLanguage.randomFixedTeachers}</h3>
                            </div>
                          </div>
                          <div className="plans">
                            <div className="payment">
                              <h2>{t("CARD_PLAN_LEVEL")}</h2>
                              <h3>{studentPlanLanguage.level}</h3>
                            </div>
                          </div>

                          {studentPlan.edit && (
                            <div className="PlansBox">
                              <div className="buttons">
                                <button onClick={(e) => handleSubmit(e, false)}>{t("BTN_CANCEL")}</button>
                                <button onClick={(e) => handleSubmit(e, true)}>{t("BTN_SAVE")}</button>
                              </div>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>

                  {studentPlan.studentPlanPayments?.length > 0 && (
                    <>
                      {studentPlan.studentPlanPayments[0].newPlan &&
                        studentPlan.studentPlanPayments[0].providerState !== "Cancelled" && (
                          <>
                            {moment().isBefore(studentPlan.studentPlanPayments[0]?.providerNextCycleDate) && (
                              <div className="box">
                                <div className="PlansBox newPlan">
                                  <div className="plans">
                                    <img src={IconPricing} alt="" width="40" height="40" />
                                    <div className="changePlan">
                                      <h2>{studentPlan.studentPlanPayments[0].newPlan.nameEnglish}</h2>
                                    </div>
                                  </div>

                                  <p style={{ color: "#00D36A", fontWeight: "bold", fontSize: 14 }}>
                                    {t("DATE_CHANGE_PLAN")}{" "}
                                    {moment(studentPlan.studentPlanPayments[0]?.providerNextCycleDate).format(
                                      t("DATE_FORMAT"),
                                    )}
                                  </p>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                    </>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {showPlan && userPlans.length === 0 && (
          <div className="planBox box centered">{"Student hasn't finalized a subscription!"}</div>
        )}

        {showManagePlan && (
          <Billing>
            <div className="box">
              <div className="topBox">
                <img src={IconPricing} alt="" width="40" height="40" />
                <h2>{selectedPlanName}</h2>
              </div>

              <ol className="tab-list">
                <div className="tabsContent">
                  <li
                    className={showPaymentHistories ? "tab-list-item tab-list-active" : "tab-list-item"}
                    onClick={() => {
                      setIsAffiliate(false);
                      setShowPlanInfo(false);
                      setShowPaymentHistories(true);
                    }}
                  >
                    {t("BILLING_HISTORY")}
                  </li>
                  {user?.role !== "customerService" && (
                    <li
                      className={showPlanInfo ? "tab-list-item tab-list-active" : "tab-list-item"}
                      onClick={() => {
                        setIsAffiliate(false);
                        setShowPlanInfo(true);
                        setShowPaymentHistories(false);
                      }}
                    >
                      {t("MANAGE")}
                    </li>
                  )}
                  {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.affiliateId && (
                    <li
                      className={isAffiliate ? "tab-list-item tab-list-active" : "tab-list-item"}
                      onClick={() => {
                        setIsAffiliate(true);
                        setShowPlanInfo(false);
                        setShowPaymentHistories(false);
                        dispatch(
                          getAffiliateInfoById(studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.affiliateId),
                        ).then((res) => setInfoAffiliate(res));
                      }}
                    >
                      {t("AFFILIATE")}
                    </li>
                  )}
                </div>
              </ol>
            </div>
            {showPaymentHistories && (
              <Billing>
                {studentPlanSelected?.studentPlan?.studentPlanPayments[0].studentPlanPaymentHistories
                  .sort((a, b) => a.id - b.id)
                  .slice(0)
                  .reverse()
                  .map((history, index) => (
                    <div key={index} className="box">
                      <div className="boxInfo">
                        <div className="infoBilling">
                          <h2>{t("DATE")}</h2>
                          <h3>
                            <span>{moment(history.createdAt).format(t("DATE_FORMAT") + " " + "HH:mm")}</span>
                          </h3>
                        </div>
                        <div className="infoBilling">
                          <h2>{t("PAYMENT_METHOD")}</h2>
                          <h3>
                            <span>{studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.provider}</span>
                          </h3>
                        </div>
                        <div className="infoBilling word-wrap-break">
                          <h2>{t("TRANSACTION_ID")}</h2>
                          <h3>
                            <span>
                              {history?.invoiceCode ??
                                studentPlanSelected?.studentPlan?.studentPlanPayments[0].providerTransactionId}
                            </span>
                          </h3>
                        </div>
                        <div className="infoBilling">
                          <h2>{t("VALUE")}</h2>
                          <h3>
                            <span>
                              {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.currency === "BRL"
                                ? "R$ "
                                : "U$ "}
                              {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.finalPrice}
                            </span>
                          </h3>
                        </div>
                        <div className="infoBilling">
                          <h2>{t("STATUS")}</h2>
                          <h3>
                            <span>{history.providerState}</span>
                          </h3>
                        </div>
                        {(studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.provider === "stripe" ||
                          studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.provider === "stripeBR") &&
                          history?.invoiceLink !== null && (
                            <div className="infoBilling">
                              <a href={history?.invoiceLink} alt="linkInvoice" target="_blank" rel="noreferrer">
                                <ButtonMB title={t("INVOICE")} />
                              </a>
                            </div>
                          )}
                      </div>
                    </div>
                  ))}
              </Billing>
            )}

            {showPlanInfo && (
              <Billing>
                <div className="box">
                  <div className="boxInfo">
                    {studentPlanSelected?.studentPlan.studentPlanPayments?.length > 0 && (
                      <div className="pagamento">
                        <div className="plans">
                          <div className="payment">
                            <h2>{t("PAYMENT_METHOD").toUpperCase()}</h2>
                            <h3>{studentPlanSelected.studentPlan.studentPlanPayments[0].provider}</h3>
                          </div>
                        </div>
                        <div className="plans">
                          <div className="payment">
                            <h2>{t("VALUE").toUpperCase()}</h2>
                            <h3>
                              {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.currency === "BRL"
                                ? "R$ "
                                : "U$ "}
                              {studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.finalPrice}
                            </h3>
                          </div>
                        </div>
                        <div className="plansButtons">
                          {!studentPlanSelected.cancels ? (
                            <>
                              <div className="payment">
                                {!studentPlanSelected.hasCancelDate ? (
                                  <SCButtonAddInput
                                    name="remove"
                                    onClick={() => handleCancelPlan(studentPlanSelected.studentPlan)}
                                  >
                                    {t("CANCEL_PLAN")}
                                  </SCButtonAddInput>
                                ) : (
                                  <SCButtonAddInput
                                    name="new"
                                    onClick={() => handleRenovatePlan(studentPlanSelected.studentPlan)}
                                  >
                                    {t("PLAN_RENOVATION")}
                                  </SCButtonAddInput>
                                )}
                              </div>
                              {studentPlanSelected.studentPlan.studentPlanPayments[0].provider !== "paypal" && (
                                <div className="payment">
                                  <SCButtonAddInput
                                    name="remove"
                                    onClick={() => handleCancelPlanImmdiate(studentPlanSelected.studentPlan)}
                                  >
                                    {t("CANCEL_IMMEDIATE")}
                                  </SCButtonAddInput>
                                </div>
                              )}
                            </>
                          ) : (
                            <div className="planCancel">{t("CANCELLED_PLAN")}</div>
                          )}
                          {!studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.refundDate &&
                            studentPlanSelected.studentPlan.studentPlanPayments[0].provider !== "paypal" && (
                              <div className="payment">
                                <SCButtonAddInput
                                  name="new"
                                  onClick={() => handleRefund(studentPlanSelected.studentPlan)}
                                >
                                  {t("REFUND")}
                                </SCButtonAddInput>
                              </div>
                            )}
                        </div>
                        <div className="payment">
                          {!studentPlanSelected.cancels && !studentPlanSelected.hasCancelDate
                            ? null
                            : textCancelClass(
                                studentPlanSelected.studentPlan,
                                t,
                                studentPlanSelected?.studentPlan?.studentPlanPayments[0]?.providerCancelDate,
                              )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </Billing>
            )}

            {isAffiliate && infoAffiliate && (
              <Billing>
                <div className="box">
                  <div className="boxInfo justify-start">
                    <div className="infoBilling">
                      <h2>Slug</h2>
                      <h3>
                        <span>{infoAffiliate?.slug}</span>
                      </h3>
                    </div>
                    <div className="infoBilling">
                      <h2>Affiliate Name</h2>
                      <h3>
                        <span>{infoAffiliate?.user?.name}</span>
                      </h3>
                    </div>
                  </div>
                </div>
              </Billing>
            )}

            <div className="buttons">
              <a
                onClick={() => {
                  setShowManagePlan(false);
                  setShowPaymentHistories(true);
                  setShowPlanInfo(false);
                }}
              >
                <SCButtonAddInput background="#004fff" color="#fff">
                  <i className="fa fa-angle-left" aria-hidden="true"></i>
                  {t("BACK")}
                </SCButtonAddInput>
              </a>
            </div>
          </Billing>
        )}
      </StudentManagementCss>

      <Dialog
        open={openalert}
        onClose={closeAlert}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title" className="titleCancelClass">
          {t("CANCEL_PLAN")}
        </DialogTitle>

        {responseError === "" && !sucessMsg ? (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>{`We’re sad you are leaving us :(`}</h3>
                  <h3>{`Why do you want to cancel your plan?`}</h3>
                  <span style={{ color: "red", fontSize: "14px" }}></span>
                  <textarea
                    required
                    type="text"
                    id="reasonForcancellation"
                    name="reasonForcancellation"
                    value={reasonForcancellation}
                    className="input-lingo inputManage"
                    onChange={(e) => setReasonForcancellation(e.target.value)}
                    placeholder="Please tell us why you want to cancel your plan"
                  />
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={submitCancel} color="secondary" autoFocus>
                {t("CANCEL_PLAN")}
              </Button>
              <Button onClick={closeAlert} color="primary" autoFocus>
                {t("NO")}
              </Button>
            </DialogActions>
          </div>
        ) : (
          <div style={{ padding: 30, paddingTop: 0 }}>
            <h4 style={{ paddingBottom: 30, fontSize: 20, textAlign: "center" }}>{t("SUCESS_CANCEL_PLAN_MANAGE")}</h4>

            <Button
              onClick={() => {
                closeAlert();
                getData();
              }}
              color="primary"
              autoFocus
            >
              {t("CLOSE")}
            </Button>
          </div>
        )}
      </Dialog>

      <Dialog
        open={openalertImmediate}
        onClose={closeAlertImmediate}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title" className="titleCancelClass">
          {t("CANCEL_IMMEDIATE")}
        </DialogTitle>

        {responseError === "" && !sucessMsg && (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>{t("CANCEL_IMMEDIATE_MESSAGE")}</h3>
                  <h3>{t("CANCEL_IMMEDIATE_QUESTION")}</h3>
                  <span style={{ color: "red", fontSize: "14px" }}></span>
                  <textarea
                    required
                    type="text"
                    id="reasonForcancellation"
                    name="reasonForcancellation"
                    value={reasonForcancellationimmediate}
                    className="input-lingo inputManage"
                    onChange={(e) => setReasonForcancellationimmediate(e.target.value)}
                    placeholder="Please tell us why you want to cancel your plan"
                  />
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={submitCancelImmediate} color="secondary" autoFocus>
                {t("CANCEL_PLAN")}
              </Button>
              <Button onClick={closeAlertImmediate} color="primary" autoFocus>
                {t("NO")}
              </Button>
            </DialogActions>
          </div>
        )}
        {sucessMsg && (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <div style={{ alignItems: "center", justifyContent: "center", backgroundColor: "rgba(0, 0, 0, 0)" }}>
                  <h3>{sucessMsg}</h3>
                </div>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={closeAlertImmediate} color="primary" autoFocus>
                {t("CLOSE")}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>

      <Dialog
        open={openalertRefund}
        onClose={closeAlertRefund}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title">{t("CANCEL_IMMEDIATE")}</DialogTitle>

        {responseError === "" && !sucessMsg && (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>{t("REFUND_MESSAGE")}</h3>
                  <h3>{t("REFUND_QUESTION")}</h3>
                  <span style={{ color: "red", fontSize: "14px" }}></span>
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={submitRefund} color="secondary" autoFocus>
                {t("REFUND")}
              </Button>
              <Button onClick={closeAlertRefund} color="primary" autoFocus>
                {t("NO")}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>

      <Dialog
        open={openalertRenovate}
        onClose={closeAlertRenovate}
        className="boxModal"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="pass-dialog-title">{t("PLAN_RENOVATION")}</DialogTitle>

        {responseError === "" && !sucessMsg && (
          <div style={{ paddingRight: 30, paddingLeft: 30 }}>
            <DialogContent>
              <DialogContentText id="pass-dialog-description" className="boxModal">
                <img src={cancelImg} alt="cancelImg" />

                <form className="formulario boxModal">
                  <h3>{t("PLAN_RENOVATION_MESSAGE")}</h3>
                </form>
              </DialogContentText>
            </DialogContent>
            <DialogActions className="boxModal">
              <Button onClick={submitRenovatePlan} color="secondary" autoFocus>
                {t("PLAN_RENOVATION")}
              </Button>
              <Button onClick={closeAlertRenovate} color="primary" autoFocus>
                {t("NO")}
              </Button>
            </DialogActions>
          </div>
        )}
      </Dialog>

      <Dialog
        className="boxModal"
        open={showModalCommission}
        onClose={closeModalCommission}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>{t("CREATE_COMMISSION")}</DialogTitle>

        <ModalCommission>
          {!sucessMsg ? (
            <>
              <div className="wrapperInputs">
                <label>Slug affiliate</label>
                <input
                  type="text"
                  name="affiliateSlug"
                  label={t("NAME_FULL")}
                  value={formCommission.affiliateSlug}
                  onBlur={(e) => handleAffiliateSlug(e)}
                  onChange={({ target }) => setFormCommission((state) => ({ ...state, affiliateSlug: target.value }))}
                />
              </div>
              <div className="wrapperInputs">
                <label>Name affiliate</label>
                <input
                  disabled
                  type="text"
                  label={t("NAME_FULL")}
                  value={formCommission.nameAffiliate}
                  onChange={({ target }) => setFormCommission((state) => ({ ...state, nameAffiliate: target.value }))}
                />
              </div>

              <div className="wrapperButtons">
                <Button onClick={handleModalCommission} color="primary">
                  {t("CREATE_COMMISSION")}
                </Button>
              </div>
            </>
          ) : (
            <h3 style={{ marginBottom: 30, fontSize: 18, fontWeight: "bold" }}>{t("SAVE_FORM_DESCRIPTION")}</h3>
          )}
          <Button onClick={closeModalCommission} color="secondary">
            {t("BACK")}
          </Button>
        </ModalCommission>
      </Dialog>
    </div>
  );
}

export default Plans;
